<div class="card lending-partner-program">
  <div class="lending-partner-program__lender-logo-container">
    <img *ngFor="let logoFileName of lendingPartnerLogos" class="lending-partner-program__lender-logo" [src]="'/assets/images/logos/' + logoFileName" [alt]="logoFileName">
  </div>  
  <h3 class="lending-partner-program__header">nMB Partner Program</h3>
</div>
